export default __webpack_public_path__ + "media/music/efbbbccacbf65cd365034cbc0bd0c1cd.mp3";